import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService, TranslationChangeEvent } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { RmpvOficinaService } from '../rmpv-oficina-service/rmpv-oficina.service';
import { ConversaoLibraConverte } from '../../../../shared/conversao-libra/conversao-libra-converte';
import { Filtros } from '../../../../shared/crud/Filtro/Filtros';
import { ListaBase } from '../../../../shared/crud/ListaBase';
import { IColunaGrid } from '../../../../shared/gridview/estrutura/IColunaGrid';
import { EstruturaGridViewBuilder } from '../../../../shared/gridview/EstruturaGridViewBuilder';
import { Parametro } from '../../../../shared/service-base/parametro';
import { TotalizadorDetalhes } from './totalizador-detalhes';
import { TotalizadorResumo } from './totalizador-resumo';

@Component({
  selector: 'app-rmpv-oficina-lista',
  templateUrl: './rmpv-oficina-lista.component.html',
  styleUrls: ['./rmpv-oficina-lista.component.css'],
})

export class RmpvOficinaListaComponent extends ListaBase implements OnInit {

  arrayTranslate = [{ categoria: "Cliente", chave: "rmpv.oficina.cliente" },
  { categoria: "Garantia", chave: "rmpv.oficina.garantia" },
  { categoria: "Funilaria e Pintura", chave: "rmpv.oficina.funilariaPintura" },
  { categoria: "Acessório", chave: "rmpv.oficina.acessorio" },
  { categoria: "Motos usadas", chave: "rmpv.oficina.motosUsada" },
  { categoria: "Outras Internas", chave: "rmpv.oficina.outraInterna" },
  { categoria: "Cortesia", chave: "rmpv.oficina.cortesia" },
  { categoria: "Revisão", chave: "rmpv.oficina.revisao" },
  { categoria: "Seguro/Franquia", chave: "rmpv.oficina.seguroFranquia" },
  { categoria: "Outras", chave: "rmpv.oficina.outra" },
  { categoria: "Retorno", chave: "rmpv.oficina.retorno" },
  { categoria: "Recall", chave: "rmpv.oficina.recall" },
  ];

  dadosCache = [];
  dadosMarcaCache = [];

  visualizarTotalRegistros: boolean;

  dadosResumo: TotalizadorResumo[] = [];
  dadosMarca: TotalizadorDetalhes[] = [];

  estruturaDetalhe: IColunaGrid[] = [];
  estruturaDetalheTotal: IColunaGrid[] = [];

  marca: any;
  total: TotalizadorResumo;
  totalInternas: TotalizadorResumo;
  totalMarca: TotalizadorDetalhes;
  totalizador: TotalizadorDetalhes;

  habilitaDetalheMarca = false;
  obj = {} as any;
  public exibirBotaoDetalhes: boolean;
  subscription;

  detalhe = {
    descricao: 'barraConsulta.verDetalhadoPorMes',
    icone: 'fa fa-calendar',
    acao: function () {
      this.router.navigateByUrl(this.obterUrlComFiltros(), { state: { modulo: 'oficina' } });
    }.bind(this)
  };

  constructor(service: RmpvOficinaService,
    toastr: ToastrService, router: Router,
    private translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte) {
    super(service, toastr, router);

    this.exibirBotaoNovo = false;
    this.listagemComPaginacao = false;
    this.quantidadeRegistrosPorPagina = 5;
    this.visualizarTotalRegistros = false;
    this.visualizarTotalInterna = true; // Habilita visualizar a somatória de valores RMPV interna
    this.visualizarTotalGeral = true;  // Habilita visualizar a somatória de valores RMPV geral
    this.exibirIconBotaoDetalhes = false;
    this.exibirBotaoDetalhes = true;      // habilita/desabilita o icone da coluna detalhe
    this.exibirBotaoDetalhesIcon = true;  // habilita/desabilita o icone de download
    this.nomeModulo = 'oficina';   // Nome dado ao arquivo excel gerado e ao serviço da api rmpv mensal                      

    this.getTranslate();
  }

  ngOnInit() {
    this.buscar();

    //conversaolibra
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.buscar();
      });
    //fimConversaolibra
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  async buscandoDados(): Promise<void> {
    await this.buscar()
  }

  getTranslate() {
    if (!this.dados) {
      return;
    }

    this.translate.onLangChange
      .subscribe((event: TranslationChangeEvent) => {

        if (this.dados[0]) {

          if (!this.dadosCache.length) {
            this.dadosCache = Array.from(this.dados);
            this.dadosMarcaCache = Array.from(this.dadosMarca);
          }

          this.dados = Array.from(this.dadosCache);
          this.dadosMarca = Array.from(this.dadosMarcaCache);

          this.translate
            .stream(this.arrayTranslate.map(item => item.chave))
            .subscribe(value => {

              this.dados = this.dados.map(item => Object.assign({}, item));
              this.dadosMarca = this.dadosMarca.map(item => Object.assign({}, item));

              this.dados.forEach(element => {

                this.arrayTranslate.forEach(item => {
                  if (element.categoria === item.categoria) {
                    element.categoria = value[item.chave];
                  }
                });

              });

              this.dadosMarca.forEach(element => {

                this.arrayTranslate.forEach(item => {
                  if (element.nome === item.categoria) {
                    element.nome = value[item.chave];
                  }
                });

              });


            }, error => console.log(error));

        }
      });
  }

  obterUrlComFiltros(): string {
    let url = '';
    for (const filtro in this.filtros) {
      if (this.filtros.hasOwnProperty(filtro)) {
        url += url ? '&' + filtro + '=' + this.filtros[filtro] : '?' + filtro + '=' + this.filtros[filtro];
      }
    }
    return 'rmpv/oficina/mensal' + url;
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.mercado
      || this.filtros.grupo_economico
      || this.filtros.regional
      || this.filtros.dealer
      || this.filtros.data_inicial
      || this.filtros.data_final;
  }

  getDados(response: any): any {
    return this.carregarMarcas(response['marcas']);
  }

  limpar() {
    this.dadosResumo = [];
    this.dadosMarca = [];
    this.total = new TotalizadorResumo();
    this.totalInternas = new TotalizadorResumo();
    this.totalMarca = new TotalizadorDetalhes(0, 'Total');
  }

  carregar() {
    const objFiltro = new Filtros();

    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        objFiltro.filtros.push(new Parametro(chave, this.filtros[chave]));
      }
    }

    this.service.listar([], objFiltro)
      .then(itens => {
        this.carregarMarcas(itens['marcas']);
      })
      .catch(error => {
        this.tratarErro('Erro consultando dados', 'Erro', error)
      });
  }

  carregarMarcas(lista: any[]): any {
    this.limpar();

    lista.forEach(element => {
      element.dados.forEach(element => {
        element.nome = this.categoriaTranslate(element.nome);
        element.faturamento = this.conversaoLibraConverte.conversaoLibra(element.faturamento, null, null);
        element.horasTrabalhadas = this.conversaoLibraConverte.conversaoLibra(element.horasTrabalhadas, null, null);
        element.horasVendidas = this.conversaoLibraConverte.conversaoLibra(element.horasVendidas, null, null);
        element.valorMaoObraUnitario = this.conversaoLibraConverte.conversaoLibra(element.valorMaoObraUnitario, null, null);
      });
      this.totalizarMarca(element.dados);
      this.marca = lista[0].marca;

    });

    this.carregarEstruturaResumo();

    return this.dadosResumo;
  }

  categoriaTranslate(item) {
    if (item == 'Cliente') {
      return this.translate.currentLang == "br" ? 'Cliente' : 'Client'
    }
    if (item == 'Garantia') {
      return this.translate.currentLang == "br" ? 'Garantia' : 'Guarantee'
    }
    if (item == 'Funilaria e Pintura') {
      return this.translate.currentLang == "br" ? 'Funilaria e Pintura' : 'Auto body and Paint'
    }
    if (item == 'Acessório') {
      return this.translate.currentLang == "br" ? 'Acessório' : 'Accessory'
    }
    if (item == 'Retorno') {
      return this.translate.currentLang == "br" ? 'Retorno' : 'Return'
    }
    if (item == "Motos usadas") {
      return item = this.translate.currentLang == 'br' ? 'Motos Usadas' : 'Used Motorcycles';
    }
    if (item == "Carros usados") {
      return item = this.translate.currentLang == 'br' ? 'Carros Usados' : 'Used Cars';
    }
    if (item == "Cortesia") {
      return item = this.translate.currentLang == 'br' ? 'Cortesia' : 'Courtesy';
    }
    if (item == "Revisão") {
      return item = this.translate.currentLang == 'br' ? 'Revisão' : 'Revision';
    }
    if (item == "Seguro/Franquia") {
      return item = this.translate.currentLang == 'br' ? 'Seguro/Franquia' : 'Insurance/Deductible';
    }
    if (item == 'Outras Internas') {
      return this.translate.currentLang == "br" ? 'Outras Internas' : 'Other Interns'
    }
    if (item == 'Outras') {
      return this.translate.currentLang == "br" ? 'Outras' : 'Other'
    }
    return item;
  }

  carregarEstruturaDetalheMarca() {
    this.estruturaDetalhe = this.carregarGridDetalhes();
    this.estruturaDetalheTotal = this.carregarTotalGridDetalhes(this.totalMarca);
  }

  private encontrarCategoriaResumo(element: any) {
    const index = this.dadosResumo.findIndex((item) => element.id === item.id);

    let categoria: TotalizadorResumo;

    if (index === -1) {
      categoria = new TotalizadorResumo();
      categoria.id = element.id;
      categoria.categoria = element.nome;
      this.dadosResumo.push(categoria);
    } else {
      categoria = this.dadosResumo[index];
    }
    return categoria;
  }

  private totalizarDetalhe(element: any, dados: TotalizadorDetalhes[], totalizador: TotalizadorDetalhes) {
    const index = dados.findIndex((item) => element.id === item.id);

    let categoria: TotalizadorDetalhes;

    if (index === -1) {
      categoria = new TotalizadorDetalhes(element.id, element.nome);
      dados.push(categoria);
    } else {
      categoria = dados[index];
    }

    this.adicionarValoresDetalhes(categoria, element);
    this.adicionarValoresDetalhes(totalizador, element);

    return categoria;
  }

  private adicionarValoresDetalhes(categoria: TotalizadorDetalhes, element: any) {
    categoria.faturamento += element.faturamento;
    categoria.horasTrabalhadas += element.horasTrabalhadas;
    categoria.horasVendidas += element.horasVendidas;
    categoria.maoDeObra += element.valorMaoObraUnitario;
  }

  /*********     Totalizador     ********/
  totalizarMarca(lista: any[]) {
    lista.forEach(element => {
      this.totalizarDetalhe(element, this.dadosMarca, this.totalMarca);


      const categoria: TotalizadorResumo = this.encontrarCategoriaResumo(element);

      categoria.valorMarca += element.faturamento;

      this.total.valorMarca += categoria.valorMarca;
      this.totalInternas.valorMarca += element.interna ? element.faturamento : 0;

      this.estruturaDetalheTotal = this.carregarTotalGridDetalhes(this.totalMarca);
    });
  }


  public exibirDetalhesMarca(ctx: RmpvOficinaListaComponent) {
    this.carregarEstruturaDetalheMarca();
    ctx.habilitaDetalheMarca = true;
  }


  private carregarEstruturaResumo() {
    const ctx = this;

    this.estrutura = new EstruturaGridViewBuilder()
      .addColunaW('categoria', 'rmpv.oficina.servico', '50%')
      .addColunaNumericaFormatadaWAction('valorMarca', this.marca, '', function () { ctx.exibirDetalhesMarca(ctx); })
      .build();

    var value1 = Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(this.totalInternas.valorMarca);
    this.estruturaInterna = new EstruturaGridViewBuilder()
      .addColunaW('', 'rmpv.oficina.internaRetornoUsado', '200px')
      .addColunaNumerica('', value1.replace("R$", ""))
      .build();

    var value2 = Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(this.total.valorMarca);
    this.estruturaTotal = new EstruturaGridViewBuilder()
      .addColunaW('', 'rmpv.oficina.total', '200px')
      .addColunaNumerica('', value2.replace("R$", ""))
      .build();

    this.carregarGridDetalhes();
  }

  private carregarGridDetalhes(): IColunaGrid[] {
    return new EstruturaGridViewBuilder()
      .addColunaW('nome', 'rmpv.oficina.categorias', '100px')
      .addColunaNumerica('maoDeObra', 'rmpv.oficina.valorMaoObra')
      .addColunaNumerica('horasVendidas', 'rmpv.oficina.horasVendidas')
      .addColunaNumerica('horasTrabalhadas', 'rmpv.oficina.horasTrabalhadas')
      .build();
  }

  private carregarTotalGridDetalhes(totalizador: TotalizadorDetalhes): IColunaGrid[] {

    return new EstruturaGridViewBuilder()
      .addColunaW('', 'Total', '120px')
      .addColunaNumerica('', totalizador.maoDeObra.toFixed(2))
      .addColunaNumerica('', totalizador.horasVendidas.toFixed(2))
      .addColunaNumerica('', totalizador.horasTrabalhadas.toFixed(2))
      .build();
  }

  private ocultarMarca() {
    this.habilitaDetalheMarca = false;
  }

  ngAfterViewChecked() {
  }

}
